import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { CheckCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { APP_COLORS } from '../../helpers/constants'

const INACTIVITY_TIMEOUT = 30

const InactivityModal = ({ onReset, onStayActive }) => {
  const { t } = useTranslation(['package-room', 'common'])
  const [countdown, setCountdown] = useState(INACTIVITY_TIMEOUT)

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer)
          onReset()
          return 0
        }
        return prevCount - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [onReset])

  return (
    <div className="inactivity-modal">
      <div className="package-room__content package-room__content--full">
        <div className="package-room__access-container">
          <CheckCircle size={80} weight="thin" color={APP_COLORS.black300} />
          <h2 className="inactivity-modal__title">{t('package-room:inactivityModal.stillHere')}</h2>
          <div className="inactivity-modal__countdown">
            <div
              className="inactivity-modal__timer"
              style={{
                background: `radial-gradient(closest-side, white 95%, transparent 80% 100%), conic-gradient(${
                  APP_COLORS.red500
                } ${(countdown / INACTIVITY_TIMEOUT) * 100}%, #e0e0e0 0)`,
              }}
            >
              <span className="inactivity-modal__seconds">{countdown}</span>
              <span className="inactivity-modal__label">
                {t('package-room:inactivityModal.seconds')}
              </span>
            </div>
          </div>
        </div>

        <div className="package-room__action-buttons">
          <button className="package-room__submit-button" onClick={onStayActive}>
            {t('common:booleans.yes')}
          </button>
        </div>
      </div>
    </div>
  )
}

InactivityModal.propTypes = {
  onReset: PropTypes.func.isRequired,
  onStayActive: PropTypes.func.isRequired,
}

export default InactivityModal
